import { network } from 'services/network';
import { useMutation } from 'react-query';
import qs from 'qs';
import { QueryResponse } from 'api/queries/getSubProgramPreferencePartialCompletion.query';

const mutationFn = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/setSubProgramPreferencePartialCompletion${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};

export const useMutationSetSubProgramPreferencePartialCompletion = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    subProgramId: number;
    option: QueryResponse;
}
